import { createContext, useContext, useEffect, useMemo, useState } from "react";

const CartContext = createContext(null);
const KEY = "px_cart";

export const CartProvider = ({ children }) => {
  const [items, setItems] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem(KEY)) || [];
    } catch {
      return [];
    }
  });

  useEffect(() => {
    localStorage.setItem(KEY, JSON.stringify(items));
  }, [items]);

  const value = useMemo(() => {
    const add = (item) =>
      setItems((prev) => {
        const found = prev.find((p) => p.key === item.key);
        if (found) return prev.map((p) => (p.key === item.key ? { ...p, qty: p.qty + item.qty } : p));
        return [...prev, item];
      });
    const setQty = (key, qty) =>
      setItems((prev) => (qty <= 0 ? prev.filter((p) => p.key !== key) : prev.map((p) => (p.key === key ? { ...p, qty } : p))));
    const clear = () => setItems([]);
    const total = items.reduce((s, i) => s + i.unit_price * i.qty, 0);
    const count = items.reduce((s, i) => s + i.qty, 0);
    return { items, add, setQty, clear, total, count };
  }, [items]);

  return <CartContext.Provider value={value}>{children}</CartContext.Provider>;
};

export const useCart = () => useContext(CartContext);
